import { z } from 'zod';

// Mirrors `backend/src/schemas/eventSettings.js` so the admin form
// validates the same shape the server will reject. Kept as a manual
// duplicate on purpose: ~25 LOC, no shared package, no build plumbing.
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const HH_MM = /^\d{2}:\d{2}$/;
// Allow-listed Google Maps hosts + share-link shortener. Empty string is
// valid ("no link"); any non-empty value must match this regex.
const MAPS_RE = /^https:\/\/(www\.)?(google\.com\/maps|maps\.google\.com|maps\.app\.goo\.gl)\/.+/;

const mapsUrl = z.union([
  z.literal(''),
  z.string().regex(MAPS_RE, 'URL de Google Maps inválida'),
]);

export const updateBodySchema = z
  .object({
    event_date: z.string().regex(ISO_DATE, 'Fecha inválida (YYYY-MM-DD)'),
    event_time: z.string().regex(HH_MM, 'Hora inválida (HH:MM)'),
    rsvp_deadline: z
      .string()
      .regex(ISO_DATE, 'Fecha límite inválida (YYYY-MM-DD)'),
    location: z.object({
      venue: z.string().min(1, 'El lugar no puede estar vacío').max(200),
      city: z.string().min(1, 'La ciudad no puede estar vacía').max(120),
      country: z.string().min(1, 'El país no puede estar vacío').max(120),
      maps_url: mapsUrl,
    }),
    ceremony_venue: z
      .string()
      .min(1, 'El lugar no puede estar vacío')
      .max(200, 'Máximo 200 caracteres'),
    ceremony_maps_url: mapsUrl,
    reception_time: z
      .string()
      .regex(HH_MM, 'Hora inválida (HH:MM)'),
  })
  .strict();
